import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-dialog-file',
  templateUrl: './dialog-file.component.html',
  styleUrls: ['./dialog-file.component.scss']
})
export class DialogFileComponent implements OnInit {
  selectedPj: any;
  index = 0;
  hasNext = false;
  hasPrev = false;
  loading = false;

  constructor(public dialogRef: MatDialogRef<DialogFileComponent>,
              @Inject(MAT_DIALOG_DATA) public pjs: any) { }

  ngOnInit() {
    this.selectPj();
  }

  close(): void {
    this.dialogRef.close();
  }

  selectPj() {
    this.selectedPj = this.pjs[this.index];
    this.hasNext = this.index < (this.pjs.length - 1);
    this.hasPrev = this.index > 0;
  }
  next() {
    this.index++;
    this.selectPj();
  }

  prev() {
    this.index--;
    this.selectPj();
  }

  onLoading(loading: boolean) {
    setTimeout(() => this.loading = loading);
  }
}
